export default __webpack_public_path__ + "static/media/CHANGELOG.ab47cca4.md";